// stores/useNeedFiltersStore.ts
import { create } from "zustand";

interface NeedFiltersState {
  districtId: number | null;
  stateId: number | null;
  areasId: number | null;
  concerningToId: number | null;
  status: number | null;
  cityId: number | null;
  subcategoryId: number | null;
  brandId: number | null;
  startDate: string;
  endDate: string;
  paginationModel: { page: number; pageSize: number };
  searchValue: string;
  applyFilter: boolean;

  // setters
  setDistrictId: (v: number | null) => void;
  setStateId: (v: number | null) => void;
  setAreasId: (v: number | null) => void;
  setConcerningToId: (v: number | null) => void;
  setStatus: (v: number | null) => void;
  setCityId: (v: number | null) => void;
  setSubcategoryId: (v: number | null) => void;
  setBrandId: (v: number | null) => void;
  setStartDate: (v: string) => void;
  setEndDate: (v: string) => void;
  setPaginationModel: (v: { page: number; pageSize: number }) => void;
  setApplyFilter: (v: boolean) => void;
  setSearchValue: (v: string) => void;
  // reset all
  resetFilters: () => void;
}

export const useNeedFiltersStore = create<NeedFiltersState>((set) => ({
  districtId: null,
  stateId: null,
  areasId: null,
  concerningToId: null,
  status: null,
  cityId: null,
  subcategoryId: null,
  brandId: null,
  startDate: "",
  endDate: "",
  paginationModel: { page: 1, pageSize: 10 },
  applyFilter: true,
  searchValue:'',

  setDistrictId: (v) => set({ districtId: v }),
  setStateId: (v) => set({ stateId: v }),
  setAreasId: (v) => set({ areasId: v }),
  setConcerningToId: (v) => set({ concerningToId: v }),
  setStatus: (v) => set({ status: v }),
  setCityId: (v) => set({ cityId: v }),
  setSubcategoryId: (v) => set({ subcategoryId: v }),
  setBrandId: (v) => set({ brandId: v }),
  setStartDate: (v) => set({ startDate: v }),
  setEndDate: (v) => set({ endDate: v }),
  setPaginationModel: (v) => set({ paginationModel: v }),
  setApplyFilter: (v) => set({ applyFilter: v }),
  setSearchValue: (v) => set({ searchValue: v }),

  resetFilters: () =>
    set({
      districtId: null,
      stateId: null,
      areasId: null,
      concerningToId: null,
      status: null,
      cityId: null,
      subcategoryId: null,
      brandId: null,
      startDate: "",
      endDate: "",
      applyFilter: true,
    }),
}));

export function useActiveNeedFilterCount() {
  const filters = useNeedFiltersStore();

  // Keys we consider as “filters” (not pagination or flags)
  const filterKeys: (keyof typeof filters)[] = [
    "districtId",
    "stateId",
    "areasId",
    "concerningToId",
    "status",
    "cityId",
    "subcategoryId",
    "brandId",
    "startDate",
    "endDate",
    "searchValue",
  ];

  return filterKeys.reduce((count, key) => {
    const val = filters[key];
    if (val !== null && val !== "" && !(typeof val === "object")) count++;
    return count;
  }, 0);
}